<template>
  <div class="order-records-view">
    <StandardSearchPageView
      ref="table"
      rowKey="orderId"
      :colNum="4"
      :columns="getColumns()"
      :queryParams="queryParams"
      :searchOptions="searchOptions"
      :requestPromise="loadDataList"
    >
    </StandardSearchPageView>
  </div>
</template>

<script>
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'

export default {
  name: 'OrderRecordsComponent',
  mixins: [],
  components: {
    StandardSearchPageView
  },
  data() {
    return {
      queryParams: {},
      searchOptions: [
        {
          name: '订单编号',
          key: 'orderId',
          type: 'input',
          placeholder: '请输入订单编号'
        },
        {
          name: '产品名称',
          key: 'proName',
          type: 'input',
          placeholder: '请输入产品名称'
        },
        {
          name: '石基订单号',
          key: 'orderTaskId',
          type: 'input',
          placeholder: '请输入石基订单号'
        }
      ]
    }
  },

  mounted() {

  },
  methods: {
    loadDataList(params) {
      const requestParams = {
        ...params,
        ...params.limitDto,
        limitDto: undefined,
        merchantId: this.$store.getters.userInfo.merchantId
      }
      return this.getHttpServices().getSourceService().post('shiji/platform/order_list', requestParams)
    },
    getColumns() {
      return [
        {
          title: '订单编号',
          dataIndex: 'orderId',
          width: '180px'
        },
        {
          title: '石基订单号',
          dataIndex: 'orderTaskId',
          width: '120px'
        },
        {
          title: '酒店确认号',
          dataIndex: 'orderTaskShijiHotelOrderNo',
          width: '180px'
        },
        {
          title: '产品名称',
          dataIndex: 'proName',
          width: '400px',
          ellipsis: true
        },
        {
          title: '订单状态',
          dataIndex: 'stateName',
          width: '120px'
        },
        {
          title: '集团订单确认号',
          dataIndex: 'internalOrderNo',
          width: '180px'
        },
        {
          title: '来源',
          dataIndex: 'sourceName',
          width: '120px'
        },
        {
          title: '下单时间',
          dataIndex: 'createTime',
          width: '180px'
        }
      ]
    }
  }
}
</script>

<style scoped>
.order-records-view {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
}
</style>
